module.exports = __webpack_public_path__ + "static/img/star5-yellow.461cdddc.png";